   //export const APP_BASE_PATH = 'http://localhost:4000/';    //use this for development enviourment
   export const APP_BASE_PATH = 'https://api.masterclasswithsap.com/';    //use this for production enviourment












  export const LOGIN_BASE_PATH = `${APP_BASE_PATH}api/login`;
  export const ADMIN_BASE_PATH = `${APP_BASE_PATH}api/admin`;
  export const FEEDBACK_BASE_PATH = `${APP_BASE_PATH}api/feedback`; 